import { render, staticRenderFns } from "./VoompPlay.vue?vue&type=template&id=0233ac70"
import script from "./VoompPlay.vue?vue&type=script&lang=js"
export * from "./VoompPlay.vue?vue&type=script&lang=js"
import style0 from "./VoompPlay.vue?vue&type=style&index=0&id=0233ac70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports